<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import GetDocumentButton from './GetDocumentButton.vue'
import GenericAlert from './GenericAlert.vue';
import { httpRequest } from '@/plugins/utils/httpRequest.js'
import { REFRESH_SHIP_PLACEMENT } from '@/plugins/utils/events.js'

const props = defineProps({
  shipDetailAttach: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const { t } = useI18n()

const isActive = ref(false)
const deleteConfirmDialog = ref(false)
const fileToDelete = ref(null)

const toggleContainer = () => {
  isActive.value = !isActive.value
}

const attachedFiles = computed(() => {
  if (props.shipDetailAttach && props.shipDetailAttach.attachedFiles) {
    return props.shipDetailAttach.attachedFiles
  }
  return []
})

const selectedShipId = computed(() => {
  if (props.shipDetailAttach && props.shipDetailAttach.shipId) {
    return props.shipDetailAttach.shipId
  }
  return null
})

const removeAttachedFile = (file) => {
  fileToDelete.value = file
  deleteConfirmDialog.value = true
}

const closeModal = () => {
  fileToDelete.value = null
  deleteConfirmDialog.value = false
}

const confirmDelete = async () => {
  await httpRequest(`/shippattern/deleteAttachedFile/${selectedShipId.value}`, { method: 'POST', body: { fileToDelete: fileToDelete.value.uniqueName } }, true, true)
  closeModal()
  document.dispatchEvent(new CustomEvent(REFRESH_SHIP_PLACEMENT, { detail: selectedShipId.value }))
}
</script>

<template>
  <div class="attached-files-container">
    <button :class="{ active: isActive }" @click="toggleContainer">
      <i class="icon-attach" />
    </button>
    <div v-if="isActive && selectedShipId" class="attached-files-content">
      <div class="title">
        {{ t('attached-files') }}
      </div>
      <table>
        <tbody>
          <tr v-for="(file, index) of attachedFiles" :key="index">
            <td class="name-container">
              {{ file.name }}
            </td>
            <td class="btn-action-container">
              <get-document-button static :url="file.url" />
              <button class="suppr-btn" @click="removeAttachedFile(file)">
                <i class="icon-trash" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <Teleport to="body">
    <generic-alert
      :title="t('delete-attached-file')"
      :alert-active="deleteConfirmDialog"
      :confirm-text="t('confirm')"
      :cancel-text="t('cancel')"
      @close-alert="closeModal"
      @confirm-alert="confirmDelete"
    >
      <div class="delete-attached-file-dialog-content">
        <div v-if="fileToDelete" class="info-delete">
          <div class="attention">
            <i class="icon-attention" />
            {{ t('attention') }}
            <i class="icon-attention" />
          </div>
          <div class="message">
            {{ t('message-delete') }}
          </div>
          <div class="file-info">
            {{ fileToDelete.name }}
          </div>
          <div class="message">
            {{ t('message-delete-warning') }}
          </div>
        </div>
      </div>
    </generic-alert>
  </Teleport>
</template>

<i18n src="@/locales/modulesControls.json"></i18n>